/**
 * Unauthenticated token endpoint. Always mounted before JWT and the app-version
 * gate so a disabled grant is 404 (not 409).
 */
export const AUTH0_LOCALHOST_ROPG_PATH = '/auth/localhost-ropg';

/** sessionStorage flag so logout is not immediately undone by password grant. */
export const AUTH0_LOCALHOST_ROPG_SKIP_KEY = 'nodon.localhost-ropg.skip';

/** localStorage key for tokens from localhost ROPG (never used on hosted hosts). */
export const AUTH0_LOCALHOST_ROPG_TOKENS_KEY = 'nodon.localhost-ropg.tokens';
